module.exports = __webpack_public_path__ + "img/avatar.ee2df91a.png";